import GameDefine from '../../../../tableEngine/Script/Game/Data/Config/GameDefine';

type LobbyGameDefine = GameDefine & {
    // s7GameDomain: string;
    // winslotGameDomain: string;
};

export const lobbyGameDefine: LobbyGameDefine = {
    // s7GameDomain: 'wss://api.dev.s7slot.online/api/v1/single?encrypt=false',
    // winslotGameDomain: 'ws://192.168.127.189:9010/api/v1/games',
};
export default LobbyGameDefine;
